import { useState } from "react";
import { useOperatorActions } from "../../../../utils/useOperatorActions";
import TeamProfitComponent from "../day-3/components/teamProfitComponent";
import CyberBoxComponent from "../../../shared/ui/layout/CyberBoxComponent";
import WelcomeComponent from "../day-1/components/welcomeComponent";
import CaptainVsTeamComponent from "./components/CaptainVSTeamComponent";

export function Day7() {
  const [currentHtml, setCurrentHtml] = useState(null);
  useOperatorActions("SHOW_CAPTAIN_VS_TEAM", () => {
    setCurrentHtml("SHOW_CAPTAIN_VS_TEAM");
  });

  const renderHtml = (html) => {
    switch (html) {
      case "SHOW_CAPTAIN_VS_TEAM":
        return <CaptainVsTeamComponent />;
      default:
        <WelcomeComponent />;
    }
  };
  return <CyberBoxComponent>{renderHtml(currentHtml)}</CyberBoxComponent>;
}

export default Day7;
